// /////////////////////////
// ! In future all components should rewrites on IntegrationsApiActionsV2
// /////////////////////////
import * as endpoints from '../../../constants/EndpointConstants.js';
import JourneyProviders from '../../../constants/JourneyProviders.js';
import { axiosGet, axiosPatch } from '../../middleware/index.js';
import * as constants from './constants/Integrations.js';

type typeObject = {
  [key: string]: any;
};

export function getAdformAdvertisers(integrationId: string) {
  const GET_ADFORM_ADVERTISERS_TYPES = [
    constants.GET_ADFORM_ADVERTISERS.REQUEST,
    constants.GET_ADFORM_ADVERTISERS.SUCCESS,
    constants.GET_ADFORM_ADVERTISERS.FAILED,
  ];

  const PATH = `${endpoints.ADFORM_ADVERTISERS}?integration=${integrationId}`;

  return axiosGet(PATH, GET_ADFORM_ADVERTISERS_TYPES);
}

export function patchAdformAdvertiser(
  provider: string,
  data: typeObject,
  { id }: { id: string },
) {
  const PATCH_ADFORM_ADVERTISER_TYPES = [
    constants.PATCH_ADFORM_ADVERTISER.REQUEST,
    constants.PATCH_ADFORM_ADVERTISER.SUCCESS,
    constants.PATCH_ADFORM_ADVERTISER.FAILED,
  ];

  const PATH = `${endpoints.GET_INTEGRATION_LINK(
    provider,
    id,
  )}activate_advertiser/`;

  return axiosPatch(PATH, PATCH_ADFORM_ADVERTISER_TYPES, data, {
    provider: JourneyProviders.ADFORM,
    integrationId: id,
  });
}
